import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ResourcesHome from '~/apps/Home'
import ResourcesView from '~/apps/View'

const Resources = () => {
   const match = useRouteMatch()

   return (
      <Switch>
         <Route exact path={match.path} component={ResourcesHome} />
         <Route path={`${match.path}/:initiativeSlug`} component={ResourcesView} />
      </Switch>
   )
}

export default Resources
